import Cookies from 'js-cookie'

const RentPopup = () => {
  const prevOnload = window.onload;

  window.onload = () => {
    /**
     * Disable the rent popup because of the meetwagen modal that now shows up. Delete this return statement if u want the popup to show again.
     */
    return;

    if (typeof prevOnload === 'function') {
      prevOnload()
    }

    const container = document.querySelector('.js-rent-popup')
    if (!container) return
    const close = container.querySelector('.js-rent-popup-close')

    // Don't show popup if have cookie
    if (Cookies.get('voltens_rent_popup')) {
      return
    }

    // Save currentTime+30s in session
    if (!sessionStorage.getItem('rent-popup')) {
      let now = new Date()
      const timeToTrigger = now.setSeconds(now.getSeconds() + 5)
      sessionStorage.setItem('rent-popup', timeToTrigger)
    }
    // Show popup after 30s
    if (sessionStorage.getItem('rent-popup')) {

      let timer = setInterval(() => {
        if (sessionStorage.getItem('rent-popup') < new Date()) {
          container.classList.add('active')
          clearInterval(timer)
        }
      }, 1000)
    }

    // Remove popup after clicking away
    close.addEventListener('click', e => {
      e.preventDefault()
      container.classList.remove('active')

      // set cookie to show it was clicked_away
      Cookies.set('voltens_rent_popup', 'rejected', { expires: 1 })

      // gtm event
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'rejectedRentPopup',
      })

      // remove session
      sessionStorage.removeItem('rent-popup')
    })

  } // onLoad
}

export default RentPopup

// WEBPACK FOOTER //
// ./src/js/modules/RentPopup.js